import configuration from 'chimera/all/store/configuration'

export default configuration
